import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgStarIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M12 3 9 9l-6 1 4 4.572L5.999 21 12 18l6 3-1.001-6.428L21 10l-6-1-3-6Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgStarIcon);
const Memo = memo(ForwardRef);
export default Memo;
